export enum OrderStyleTestThreeDotMenuButtonEnum {
  DELETE_BTN = 'delete-btn',
  EDIT_OR_VIEW_BTN = 'edit-or-view-btn',
  THREE_DOT_MENU_BTN = 'three-dot-menu-btn',
  REQUEST_CANCELLATION_BTN = 'request-cancellation-btn',
  CONVERT_BTN = 'convert-btn',
  GLOBAL_OVERRIDE_BTN = 'global-override-btn',
}
